<template>
    <v-simple-table class="white">
        <template v-slot:default>
        <thead>
            <tr>
                <th v-for="item in Headers" :key="item.value" class="text-left my-border customlightgray">
                    {{item.text}}
                </th>
            </tr>
        </thead>
        <tbody>
            <tr
            v-for="item in List"    
            :key="item.res"
            >     
                <td class="my-border customoffwhite">{{ item.res }}</td>
                <td class="my-border customoffwhite">{{ item.per }}</td>
            </tr>
        </tbody>
        </template>
    </v-simple-table>
</template>

<script>
export default {
  components: {
  },
  props: ['daterange','requests'],
  data () {
    return {
        Headers:[
            {text:this.$t('Resources'),value:'res'},
            {text:this.$t('Person Years Dedicated to Access to Information Activities'),value:'per'}, 
        ],
        List:[
                {res:this.$t('Full-time employees'),per:'0'},
                {res:this.$t('Part-time and casual employees'),per:'0'},
                {res:this.$t('Regional staff'),per:'0'},
                {res:this.$t('Consultants and agency personnel'),per:'0'},
                {res:this.$t('Students'),per:'0'},
                {res:this.$t('Total'),per:'0'},
        ],
    }
  },
  mounted () {
  },
  async created(){ 
  },
  computed:{  
  },
  methods: {
  },
  watch: {
  }
}
</script>

<style scoped lang="scss">
</style>